class DateCounter extends HTMLElement {
  constructor() {
    super();
    this.countdownDateAttr = this.getAttribute("data-end-date");
    this.countdownDate = this.parseDate(this.countdownDateAttr);
    console.log(this.countdownDate);
    if (isNaN(this.countdownDate)) {
      console.error("Invalid date format:", this.countdownDateAttr);
      return;
    }
  }
 
  parseDate(dateStr) {
    // Format attendu : 03/11/2025 14:30
    const dateTimeParts = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2})/);
    if (dateTimeParts) {
      const [_, day, month, year, hour, minute] = dateTimeParts;
      return new Date(year, month - 1, day, hour, minute);
    }
 
    // Si le format n'est pas reconnu, retourne une date invalide
    return new Date("Invalid Date");
  }
 
  connectedCallback() {
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }
 
  disconnectedCallback() {
    clearInterval(this.interval);
  }
 
  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.countdownDate.getTime() - now;
 
    if (distance < 0) {
      this.querySelector(".countdown-block__timer").textContent = this.dataset.timerEndedText;
      clearInterval(this.interval);
      return;
    }
 
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
 
    // Affichage des jours, même s'ils sont à 0
    this.querySelector("#days").textContent = days;
    this.querySelector("#hours").textContent = hours;
    this.querySelector("#minutes").textContent = minutes;
    this.querySelector("#seconds").textContent = seconds;
  }
}
 
customElements.define("date-counter", DateCounter);